import { BreadcrumbsService } from './../services/breadcrumbs.service';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main',
  templateUrl: './domain.component.html'
})
export class DomainComponent implements OnInit {

  constructor(
    private breadcrumbsService: BreadcrumbsService
  ) { }

  ngOnInit() {
    this.breadcrumbsService.translateBreadcrumb('/domains', 'Domeny');
    this.breadcrumbsService.translateBreadcrumb('/domains/records', 'Dashboard');
    this.breadcrumbsService.translateBreadcrumb('/domains/list', 'Lista domen');
  }

}



// WEBPACK FOOTER //
// ./src/app/domain/domain.component.ts